<template>
  <content-container :table-row-count="tableData.length">
    <!-- 搜索条件区域 -->
    <search-container>
      <search-col>
        <el-input v-model="params.dutyNo" placeholder="任务编号" clearable @keydown="onEnter" />
      </search-col>
      <search-col>
        <el-input v-model="params.dutyName" placeholder="任务名称" clearable @keydown="onEnter" />
      </search-col>
      <search-col v-if="isServer">
        <el-input v-model="params.serverName" placeholder="服务主体" clearable @keydown="onEnter" />
      </search-col>
      <search-col v-if="!isHnFreePartners">
        <el-select
          v-model="params.proxyPayType"
          filterable
          placeholder="收入性质"
          clearable
        >
          <el-option :label="proxyPayTypeConfig[EProxyPayType.BUSINESS_INCOME]" :value="EProxyPayType.BUSINESS_INCOME" />
          <el-option :label="proxyPayTypeConfig[EProxyPayType.LABOR_REMUNERATION]" :value="EProxyPayType.LABOR_REMUNERATION" />
        </el-select>
      </search-col>
      <search-col>
        <el-select
          v-model="params.invoiceTaxMethod"
          filterable
          placeholder="开票方式"
          clearable
        >
          <el-option :label="invoiceTaxMethodConfig[EInvoiceTaxMethod.FULL_AMOUNT_TAX]" :value="EInvoiceTaxMethod.FULL_AMOUNT_TAX" />
          <el-option :label="invoiceTaxMethodConfig[EInvoiceTaxMethod.DIFFERENTIAL_TAX]" :value="EInvoiceTaxMethod.DIFFERENTIAL_TAX" />
        </el-select>
      </search-col>
      <search-col v-if="isSass||isServer">
        <el-select
          v-model="params.taxSourceType"
          filterable
          placeholder="个人发票税源地"
          clearable
        >
          <el-option :label="personalInvoiceTaxSourceLocationLabel[ETaxSourceType.Mainland]" :value="ETaxSourceType.Mainland" />
          <el-option :label="personalInvoiceTaxSourceLocationLabel[ETaxSourceType.Hainan]" :value="ETaxSourceType.Hainan" />
        </el-select>
      </search-col>
      <search-col>
        <el-select
          v-model="params.invoiceSubId"
          filterable
          placeholder="开票科目"
          clearable
        >
          <el-option
            v-for="item in invoiceSubList"
            :key="item.id"
            :label="item.invoiceSubName"
            :value="item.id"
          />
        </el-select>
      </search-col>
      <search-col v-if="!isServer">
        <el-input v-model="params.serverName" placeholder="服务主体" clearable @keydown="onEnter" />
      </search-col>
      <search-col>
        <el-date-picker
          v-model="dateRange" type="daterange" style="width: 100%;" value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD" start-placeholder="开始时间(起)" end-placeholder="结束时间(止)" @keydown.enter="doSearch"
        />
      </search-col>
      <search-col>
        <el-select v-model="params.status" filterable placeholder="任务状态" clearable @keyup.enter="doSearch">
          <el-option :label="taskStatusLabel[ETaskStatus.Audit]" :value="ETaskStatus.Audit" />
          <el-option :label="taskStatusLabel[ETaskStatus.Reject]" :value="ETaskStatus.Reject" />
          <el-option :label="taskStatusLabel[ETaskStatus.Action]" :value="ETaskStatus.Action" />
          <el-option :label="taskStatusLabel[ETaskStatus.Finish]" :value="ETaskStatus.Finish" />
        </el-select>
      </search-col>
      <search-col>
        <el-input v-model="params.companyName" placeholder="企业名称" clearable @keydown="onEnter" />
      </search-col>
      <search-col>
        <el-input v-model="params.agentName" placeholder="代理商名称" clearable @keydown="onEnter" />
      </search-col>
      <search-col v-if="isSass">
        <el-input v-model="params.relatedAgentName" placeholder="关联代理商" clearable @keydown="onEnter" />
      </search-col>

      <template #buttons>
        <el-button @click="resetForm">
          <svg-icon icon="tabler:refresh" />重置
        </el-button>
        <el-button type="primary" @click="doSearch">
          <svg-icon icon="lucide:search" />查询
        </el-button>
      </template>
    </search-container>

    <div class="pb-3">
      <el-button type="primary" @click="exportData">
        <svg-icon icon="mingcute:file-export-line" />导出
      </el-button>
    </div>

    <!-- 表格数据 -->
    <el-table
      v-loading="loading" class="normal-table" :border="true" :scrollbar-always-on="true" :data="tableData"
      :cell-style="initOperatorColumnStyle"
    >
      <el-table-column align="left" prop="tempName" label="任务类型" :min-width="180">
        <template #header>
          <div class="flex items-center justify-start">
            <svg-icon class="!w-[20px] !h-[20px] text-[var(--color-warning)] mr-3" icon="" />
            任务类型
          </div>
        </template>
        <template #default="scope">
          <div class="flex items-center">
            <el-tooltip
              v-if="scope.row.bindEmployeeStatus == EBindEmployeeStatus.BEFORE_DISTRIBUTE"
              effect="light"
              :content="scope.row.errorMsg"
              placement="top-start"
            >
              <svg-icon class="!w-[20px] !h-[20px] text-[#F98500] mr-3" icon="mingcute:alert-fill" />
            </el-tooltip>
            <el-tooltip
              v-else-if="scope.row.showTips == EYesNo.Yes && isSass"
              effect="light"
              content="该任务需要上传交付物，未上传交付物将无法进行发票开票申请"
              placement="top-start"
            >
              <svg-icon class="!w-[20px] !h-[20px] text-[#F98500] mr-3" icon="mingcute:alert-fill" />
            </el-tooltip>
            <svg-icon v-else class="!w-[20px] !h-[20px] text-[#F98500] mr-3" icon="" />
            <div class="flex-1 truncate">
              {{ scope.row.tempName }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="dutyName" label="任务名称" :min-width="120" show-overflow-tooltip />
      <el-table-column align="left" prop="invoiceSubName" label="开票科目" :min-width="120" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.invoiceSubName || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="right" prop="dutyCommission" label="任务佣金(元)" :min-width="110" show-overflow-tooltip />
      <el-table-column v-if="isServer" align="left" prop="serverName" label="服务主体" :min-width="150" show-overflow-tooltip />
      <el-table-column v-if="!isHnFreePartners" align="left" prop="proxyPayType" label="收入性质" :width="100">
        <template #default="scope">
          {{ scope.row.proxyPayType ? proxyPayTypeConfig[scope.row.proxyPayType] : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="invoiceTaxMethod" label="开票方式" :width="100">
        <template #default="scope">
          {{ scope.row.invoiceTaxMethod ? invoiceTaxMethodConfig[scope.row.invoiceTaxMethod] : '-' }}
        </template>
      </el-table-column>
      <el-table-column v-if="isSass||isServer" align="left" prop="taxSourceType" label="个人发票税源地" :width="125">
        <template #default="scope">
          {{ personalInvoiceTaxSourceLocationLabel[scope.row?.taxSourceType] || '-' }}
        </template>
      </el-table-column>
      <el-table-column v-if="!isServer" align="left" prop="serverName" label="服务主体" :min-width="140" show-overflow-tooltip />
      <el-table-column align="center" prop="status" label="任务状态" :width="100">
        <template #default="scope">
          <custom-tag :content="scope.row.status == ETaskStatus.Reject ? scope.row.rejectReason : undefined" :label="taskStatusLabel[scope.row.status]" :type="taskStatusStyle[scope.row.status]" />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="publicInMini" label="是否公开" :width="80">
        <template #default="scope">
          {{ scope.row.publicInMini === EYesNo.Yes ? yesNoLabel[EYesNo.Yes] : yesNoLabel[EYesNo.No] }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="startTime" label="开始日期" :width="110" />
      <el-table-column align="left" prop="endTime" label="结束日期" :width="110" />

      <el-table-column align="left" prop="companyName" label="企业名称" :min-width="140" show-overflow-tooltip />
      <el-table-column align="left" prop="agentName" label="代理商名称" :min-width="180" show-overflow-tooltip>
        <template #default="scope">
          <template v-if="isAgent">
            {{ isNull(scope.row.agentName) ? '--' : scope.row.agentName }}
          </template>
          <el-popover v-else :width="323" trigger="click">
            <template #reference>
              <a class="table-inner-ellipsis  h-[22px] block" @click="fetchUpperAgents(scope.row)">
                <el-tag
                  round
                  size="small"
                  type="primary"
                  class="ml-1"
                >
                  {{ agentLevelLabel[scope.row.levelType] }}
                </el-tag>
                {{ scope.row.agentName|| '-' }}
              </a>
            </template>
            <div class="text-[var(--color-text-primary)] mb-[5px]">
              上级代理商信息
            </div>
            <el-table class="normal-table" size="small" :data="upperAgents">
              <el-table-column align="center" property="levelType" label="代理商等级">
                <template #default="iscope">
                  {{ agentLevelLabel[iscope.row.levelType] }}
                </template>
              </el-table-column>
              <el-table-column align="center" property="agentName" show-overflow-tooltip label="代理商名称" />
            </el-table>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="dutyNo" label="任务编号" :min-width="150" show-overflow-tooltip />

      <el-table-column v-if="buttons.length > 0" align="center" prop="actions" fixed="right" label="操作">
        <template #default="scope">
          <table-row-buttons :buttons="buttons" :row="scope.row" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 底部分页 -->
    <template #footer>
      <el-pagination
        v-model:current-page="params.page" v-model:page-size="params.size"
        :page-sizes="[defaultPageSize, 25, 50, 100]" layout="total, sizes, prev, pager, next, jumper" :total="total"
        background @size-change="onSizeChange" @current-change="onCurrentPageChange"
      />
    </template>

    <div class="duty-qrcode-wrap">
      <el-dialog
        class="dialog-inner-scroller min-h-[623px]"
        :model-value="qrCodeVisible" align-center width="400" title="" footer=""
        :before-close="() => { qrCodeVisible = false; qrCodeUrl = ''}"
      >
        <div id="qrcode" class="duty-qrcode flex flex-col items-center w-[400px] h-[623px] pt-[100px]">
          <div class="text-[#262626] text-base h-[62px] flex items-center leading-5 mr-[60px] w-[224px] mb-1">
            {{ currentRow?.proxyPayType === EProxyPayType.LABOR_REMUNERATION ? currentRow?.serverName : currentRow.companyName }}
          </div>
          <div class="text-[#595959] flex justify-center mt-[35px] text-xs leading-6 w-[254px] ">
            {{ currentRow.dutyName }}
          </div>

          <div
            class="image-container"
          >
            <img
              class="w-full h-full"
              :src="qrCodeUrl"
              alt=""
            >
          </div>
        </div>
        <div class="absolute bottom-8">
          <el-button id="qrcode-btn" plain class="text-[#1777FF]" @click="copyImg">
            <svg-icon icon="ri:share-line" /> 分享
          </el-button>
        </div>
      </el-dialog>
    </div>
  </content-container>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { initOperatorColumnStyle, SvgIcon, TableRowButtons, CustomTag, onConfirm } from '@vue3/components';
import {
  ContentContainer,
  SearchContainer,
  SearchCol,
  useTblPermissionButtons,
  queryTaskPage,
  dutyInfoQrcode,
  useUserStore,
  queryUpperSetupAgents,
  checkAuditPermission,
  exportTaskPage,
  queryInvoiceSubjectList,
  finishDuty,
} from '@core/main';
import { 
  agentLevelLabel, 
  EApproveType, 
  IUpperSetupAgent, 
  ITaskListParam, 
  ITaskListItem, 
  ETaskStatus, 
  taskStatusLabel, 
  taskStatusStyle, 
  EYesNo, 
  yesNoLabel, 
  EBindEmployeeStatus, 
  EProxyPayType,
  proxyPayTypeConfig,
  personalInvoiceTaxSourceLocationLabel,
  ETaxSourceType,
  invoiceTaxMethodConfig,
  EInvoiceTaxMethod,
  serverCrowdCreditCode,
  // ahFreePartnerCreditCode,
} from '@core/main/types';
import { useRouter } from 'vue-router';
import { downloadFile, isNull, ScreenShot } from '@core/tools';
import { ESystemType } from '@core/api';

defineOptions({ name: 'RateLadderConfig' });

const { state: userState } = useUserStore();

const defaultPageSize = 12;
const router = useRouter();
const params = reactive<ITaskListParam>({
  page: 1,
  size: defaultPageSize,
  dutyType: 0,
});
const dateRange = ref<string[]>([]);
const loading = ref(false);
const total = ref(0);

const tableData = ref<ITaskListItem[]>([]);
const qrCodeVisible = ref(false);
const currentRow = ref({} as ITaskListItem);
const qrCodeUrl = ref('') as any;
const upperAgents = ref<IUpperSetupAgent[]>([]);
const invoiceSubList = ref([]);

const isSass = computed(() => userState?.identity?.systemType === ESystemType.SAAS);
const isAgent = computed(() => userState?.identity?.systemType === ESystemType.Agent);
const isServer = computed(() => userState?.identity?.systemType === ESystemType.Server);
const isHnFreePartners = computed(() => serverCrowdCreditCode?.includes(userState.identity?.serverDTO?.creditCode) && isServer.value);
// const isAhFreePartners = computed(() => ahFreePartnerCreditCode?.includes(userState.identity?.serverDTO?.creditCode) && isServer.value);

const { buttons } = useTblPermissionButtons([
  {
    name: '详情',
    code: '',
    action: doDetail,
  },
  {
    name: '去审核',
    code: '',
    action: toApproval,
    relationField: 'status',
    relationValue: ETaskStatus.Audit,
    systemType: [ESystemType.SAAS],
  },
  {
    name: '交付物管理',
    code: '',
    action: deliveryTask,
    relationField: 'needDeliver',
    relationValue: EYesNo.Yes,
    systemType: [ESystemType.SAAS, ESystemType.Server],
  },
  {
    name: '接包管理',
    code: '',
    action: toReceiveBag,
    relationField: 'status',
    relationValue: [ETaskStatus.Action, ETaskStatus.Finish],
    relationFilter: 'includes',
  },
  {
    name: '报名二维码',
    code: '',
    action: toRegistrationQRCode,
    relationField: 'status',
    relationValue: [ETaskStatus.Action, ETaskStatus.Finish],
    relationFilter: 'includes',
  },
  {
    name: '报名人员',
    code: '',
    action: toRegistrationPersonnel,
    relationField: 'status',
    relationValue: [ETaskStatus.Action, ETaskStatus.Finish],
    relationFilter: 'includes',
  },
  {
    name: '完结任务',
    code: 'duty:list:finish',
    action: finishTask,
    relationField: 'status',
    relationValue: ETaskStatus.Action,
    systemType: [ESystemType.SAAS],
  },
]);

async function fetchUpperAgents(row: ITaskListItem) {
  try {
    upperAgents.value = [];
    upperAgents.value = await queryUpperSetupAgents(row.agentId);
  } catch (error) {
    upperAgents.value = [];
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function fetchData() {
  loading.value = true;

  try {

    const { data, total: all } = await queryTaskPage({
      ...params,
      startTime: dateRange.value ? dateRange.value[0] : undefined,
      endTime: dateRange.value ? dateRange.value[1] : undefined,
    });

    tableData.value = data;
    total.value = all;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

function resetForm() {
  dateRange.value = [];
  for (const key in params) {
    if (!['page', 'size', 'dutyType'].includes(key)) {
      params[key] = undefined;
    }
  }
}

function onSizeChange(size: number) {
  params.size = size;
  params.page = 1;
  fetchData();
}

function onCurrentPageChange(page: number) {
  params.page = page;
  fetchData();
}

function doSearch() {
  params.page = 1;
  fetchData();
}

function onEnter(e) {
  if (e.keyCode === 13) doSearch();
}

function doDetail(row: any) {
  router.push({
    name: 'TaskDetail',
    query: { id: row.id },
  });
}

function toReceiveBag(row: any) {
  router.push({
    name: 'ReceiveBag',
    query: { taskId: row.id },
  });
}

async function toRegistrationQRCode(row: ITaskListItem) {
  try {
    qrCodeUrl.value = await dutyInfoQrcode(row.id);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  currentRow.value = row;
  qrCodeVisible.value = true;
}

async function copyImg() {
  const screenFull = new ScreenShot(document.querySelector('#qrcode')) as any;
  const a = await screenFull.getBase64String();
  const data = await fetch(a);
  const blob = await data.blob();

  await navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]);
  ElMessage.success('图片复制成功');
  // const link = document.createElement('a');

  // link.href = a;
  // link.download = '任务二维码.png'; // 下载文件的名称
  // link.click();

}

function toRegistrationPersonnel(row: ITaskListItem) {
  router.push({
    name: 'RegistrationPersonnel',
    query: {
      taskId: row.id,
      companyId: row.companyId,
      taxSourceType: row.taxSourceType,
      hnInvoiceType: row.hnInvoiceType,
    },
  });
}

async function toApproval(row: ITaskListItem) {
  const type = EApproveType.CROWD_DUTY;
  const {
    enabled,
    taskNo,
  } = await checkAuditPermission(row.id, type);

  if (!enabled) {
    ElMessage.error('您没有审核权限');
    return;
  }

  router.push({
    name: 'ApprovalForm',
    query: {
      taskNo,
      refId: row.id,
      type: type,
    },
  });
}

async function exportData() {
  try {
    const { buffer, fileName } = await exportTaskPage({
      ...params,
      startTime: dateRange.value ? dateRange.value[0] : undefined,
      endTime: dateRange.value ? dateRange.value[1] : undefined,
    });

    downloadFile(buffer, fileName, 'xlsx');
    ElMessage.success('导出成功');
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

function deliveryTask(row: ITaskListItem) {
  router.push({
    name: 'DeliveryTask',
    query: { id: row.id },
  });
}

function finishTask(row: ITaskListItem) {
  onConfirm({
    message: `是否确认手动结束 [${row.dutyName}] 吗？`,
    onOk: async () => {
      try {
        await finishDuty({ id: row.id });
        ElMessage.success('操作成功');
        doSearch();
      } catch (error) {
        if ((error as Error).message) ElMessage.error((error as Error).message);
      }
    },
  });

}

async function fetchInvoiceSubList() {
  try {
    invoiceSubList.value = await queryInvoiceSubjectList(1, 0);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

fetchInvoiceSubList();

fetchData();
</script>

<style lang="scss" scoped>
.duty-qrcode-wrap {
  .duty-qrcode{
    @apply bg-[url('@core/main/assets/images/qrcode/dutyQrcodebg.png')] bg-no-repeat bg-center bg-[length:400px_623px];
  }
  :deep(.el-dialog) {
    .el-dialog__header {
      @apply p-0;
    }

    .el-dialog__body {
      @apply p-0 flex items-center justify-center;
    }

    .image-container {
      @apply w-[200px] h-[200px] absolute bottom-[172px];
    }
  }
}
</style>
